import errorData from "@/mixins/error"
import { mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            default: ""
        }
    },
    computed:{
        ...mapGetters({
            data:'data/getData'
        })
    },
    mixins:[errorData],
    methods: {
        ...mapActions({
            clearError:'error/clearError',
            addError:'error/addError',
            evaluateExportPdf:'evaluate/exportPdf',
            shortSpinShow:'view/shortSpinShow',
            shortSpinHide:'view/shortSpinHide',
        }),
        exportPdf(){
            this.shortSpinShow()
            this.clearError()
            this.evaluateExportPdf(this.data)
                .then(response => {
                    if(response.data.inputErrorMessages == undefined && response.data.preValidateMessage == undefined && response.data.error == undefined){
                        // PDFファイルをダウンロードさせる
                        let link = document.createElement('a')
                        const base_url = 'data:application/pdf;base64,' + response.data.result
                        const byte_string = atob(base_url.split(",")[1])
                        for (var i = 0, l=byte_string.length, content = new Uint8Array( l ); i < byte_string.length; i++){
                            content[i] = byte_string.charCodeAt(i);
                        }
                        const blob = new Blob([content], {type:"application/pdf"})
                        if(navigator.msSaveOrOpenBlob){
                            // IE対応(EdgeもmsSaveOrOpenBlobに対応しているためこちらで処理されます)
                            navigator.msSaveOrOpenBlob(blob, 'report.pdf')
                        } else {
                            link.href = URL.createObjectURL(blob);
                            link.download = 'report.pdf'
                            // 実在する要素(非表示でよい)の子要素としてa要素を追加しないとChrome以外で動かない
                            document.getElementById('invisible').appendChild(link)
                            link.click()
                            document.getElementById('invisible').removeChild(link)
                        }
                        this.shortSpinHide()
                    } else {
                        if(response.data.inputErrorMessages != undefined){
                            for(let i = 0; i < response.data.inputErrorMessages.length; i++){
                                let errorMessage = response.data.inputErrorMessages[i]
                                this.addError(this.getName(errorMessage['TargetName']) + this.getError(errorMessage))
                            }
                        }
                        if(response.data.preValidateMessage != undefined){
                            this.addError(response.data.preValidateMessage)
                        }
                        if(response.data.error != undefined){
                            for(let i = 0; i < response.data.error.length; i++){
                                this.addError(response.data.error[i])
                            }
                        }
                        scroll(0,-30)
                        this.shortSpinHide()
                    }
                }, () => {
                    this.addError('PDFの出力に失敗しました')
                    scroll(0, 0)
                    this.shortSpinHide()
                })
        },
    }
}